namespace $.$$ {
	export class $shm_hitalama_map_widget_float_table_follower extends $.$shm_hitalama_map_widget_float_table_follower {

		zoom() {
			this.view_rect()
			const node = this.Sub().dom_node() as HTMLElement & { currentCSSZoom?: number }
			if( node.currentCSSZoom ) return node.currentCSSZoom
			let zoom = 1
			for( let parent: Element | null = node; parent; parent = parent.parentElement ) {
				zoom *= Number( this.$.$mol_dom_context.getComputedStyle( parent ).getPropertyValue( 'zoom' ) ) || 1
			}
			return zoom
		}

		@ $mol_mem
		pos(): { left: number, top: number } | null {
			const self = this.view_rect(), anchor = this.Anchor()?.view_rect()
			if( !anchor ) return null
			const prev = $mol_wire_probe( () => this.pos() )
			const offset = this.offset(), align = this.align(), zoom = this.zoom()
			// DOMRects are in viewport pixels; translate is in zoomed CSS pixels.
			return {
				left: Math.round( ( prev?.left ?? 0 ) + ( anchor.left + anchor.width * offset[0]
					- ( self?.left ?? 0 ) + ( self?.width ?? 0 ) * align[0] ) / zoom ),
				top: Math.round( ( prev?.top ?? 0 ) + ( anchor.top + anchor.height * offset[1]
					- ( self?.top ?? 0 ) + ( self?.height ?? 0 ) * align[1] ) / zoom ),
			}
		}
	}
}
